@let installationViewModel = installationViewModel$ | async;
<div class="installation-container">
  @if (featureSettingsService.poseEnabled) {
  <div class="body-header">
    <span class="casto-title large" [innerHTML]="'installation.kitchen.title' | translate"></span>
  </div>
  @if (installationViewModel.currentInstallation?.withInstallation ?? true) {
    <div class="panel">
      <div class="panel-content">
        <div class="casto-card">
          <div class="header">
            @if (installationViewModel.displayTitleWithoutDelta || setWithInstallationLoading) {
              <span
                class="casto-title"
                [innerHTML]="'installation.kitchen.with-installation.title-without-delta' | translate"></span>
            } @else {
              <span
                class="casto-title"
                [innerHTML]="
                  'installation.kitchen.with-installation.title'
                    | translate
                      : {
                          amount: installationViewModel.currentPricing?.delta?.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></span>
            }
          </div>
          @if (installationViewModel.currentInstallation?.withInstallation ?? true) {
            <div class="content">
              <div class="action">
                <span class="action-label" [innerHTML]="'project-info.more-2-years' | translate"></span>
                <p-selectButton
                  [options]="more2YearsOptions"
                  [(ngModel)]="more2YearsInput"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="handleOnSelectButtonChange($event)"
                  [disabled]="installationViewModel.pricingLoading || installationViewModel.installationLoading">
                  <ng-template let-item pTemplate>
                    <span [innerHTML]="'generic.' + item.label | translate"></span>
                  </ng-template>
                </p-selectButton>
              </div>
              @if ((installationViewModel.pricingLoading || installationViewModel.installationLoading || setWithInstallationLoading) && more2YearsInput !== undefined) {
                <table class="price-table">
                  <tr class="top-row">
                     <span
                       class="casto-title"
                       [innerHTML]="
                          'installation.kitchen.with-installation.top-row-title'
                            | translate
                              : {
                                  tva: installationViewModel.currentInstallation?.more2Years ? 10 : 20,
                                }
                        "></span>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                      <p-skeleton width="5rem" height="1.25rem"></p-skeleton>
                    </td>
                  </tr>

                  <!-- Ligne dédiée pour le sous-tableau -->
                  <tr>
                    <td class="inner-table-cell">
                      <table class="inner-table">
                        <tr>
                          <td>
                            <p-skeleton width="25rem" height="1rem"></p-skeleton>
                          </td>
                          <td>
                          </td>
                          <td>
                          </td>
                          <td>
                            <p-skeleton width="5rem" height="1rem"></p-skeleton>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p-skeleton width="25rem" height="1rem"></p-skeleton>
                          </td>
                          <td>
                          </td>
                          <td>
                          </td>
                          <td>
                            <p-skeleton width="5rem" height="1rem"></p-skeleton>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p-skeleton width="25rem" height="1rem"></p-skeleton>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                      <p-skeleton width="5rem" height="1rem"></p-skeleton>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p-skeleton width="25rem" height="1rem"></p-skeleton>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td class="price">
                      <p-skeleton width="5rem" height="1rem"></p-skeleton>
                    </td>
                  </tr>

                  <tr class="white">
                    <span class="ml" [innerHTML]="'installation.ml' | translate"></span>
                  </tr>
                </table>
              } @else if (installationViewModel.isInstallationValid) {
                <table class="price-table">
                  <tr class="top-row">
                    <td>
                      <span
                        class="casto-title"
                        [innerHTML]="
                          'installation.kitchen.with-installation.top-row-title'
                            | translate
                              : {
                                  tva: installationViewModel.currentInstallation?.more2Years ? 10 : 20,
                                }
                        "></span>
                    </td>
                    <td>
                      @if (displayDiscount$ | async) {
                        @if (discountNumberValue$ |async; as discountNumberValue) {
                          <span
                            class="casto-tag"
                            [innerHTML]="
                            'installation.kitchen.with-installation.top-row-tag'
                              | translate
                                : {
                                    discount: discountNumberValue,
                                    discountAmount:
                                      (-installationViewModel.currentPricing.totalWithoutFunding.discountedAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'),
                                  }
                          "></span>
                        }

                      }
                    </td>
                    <td>
                      @if (displayDiscount$ | async) {
                        <span
                          class="casto-discount"
                          [innerHTML]="
                            installationViewModel.currentPricing.totalWithoutFunding.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                          "></span>
                      }
                    </td>
                    <td>
                      <span
                        class="blue"
                        [innerHTML]="
                          installationViewModel.currentPricing.totalWithoutFunding.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                        ">
                      </span>
                    </td>
                  </tr>

                  <!-- Ligne dédiée pour le sous-tableau -->
                  <tr>
                    <td class="inner-table-cell">
                      <table class="inner-table">
                        @for (
                          detail of installationViewModel.currentPricing.detailConception | keyvalue; track detail.key) {
                          <tr>
                            <td
                              [innerHTML]="'installation.kitchen.conception-details.' + detail.key | translate"></td>

                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-tag"
                                  [innerHTML]="
                                    -detail.value.discountedAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-discount"
                                  [innerHTML]="detail.value.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                </span>
                              }
                            </td>
                            <td class="price">
                              <span
                                [innerHTML]="detail.value.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>
                            </td>
                          </tr>
                        }
                      </table>
                    </td>
                  </tr>
                  @if (installationViewModel.currentPricing.totalInstallation) {
                    <tr>
                      <td>
                        <div class="horizontal-align-with-gap">
                            <span
                              [innerHTML]="'installation.kitchen.with-installation.installation' | translate"></span>
                          <ng-casto-button
                            class="secondary"
                            (click)="openDetail()"
                            [label]="'installation.kitchen.with-installation.details' | translate"></ng-casto-button>
                        </div>
                      </td>
                      <td></td>
                      <td></td>
                      <td>
                        <span
                          class="blue"
                          [innerHTML]="
                            installationViewModel.currentPricing.totalInstallation.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                          ">
                        </span>
                      </td>
                    </tr>
                  }
                  <tr>
                    <td [innerHTML]="'installation.kitchen.delivery' | translate"></td>
                    <td></td>
                    <td></td>
                    <td>
                      <span
                        class="blue"
                        [innerHTML]="
                          installationViewModel.currentPricing.delivery.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                        ">
                      </span>
                    </td>
                  </tr>
                  @if (installationViewModel.isCustomWorkbenchOnly) {
                    <tr>
                      <td class="inner-table-cell">
                        <table class="inner-table">
                          <tr>
                            <td
                              [innerHTML]="'installation.kitchen.workbench.total-without-packages' | translate"></td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-tag"
                                  [innerHTML]="
                                    -installationViewModel.extraPricing.totalWorkbench.discountedAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-discount"
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalWorkbench.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              <span
                                class="blue"
                                [innerHTML]="
                                  installationViewModel.extraPricing.totalWorkbench.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                ">
                              </span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  } @else if (installationViewModel.isCustomWorkbench) {
                    <tr>
                      <td class="inner-table-cell">
                        <table class="inner-table">
                          <tr>
                            <td class="horizontal-align-with-gap">
                              <span [innerHTML]="'installation.kitchen.workbench.total' | translate"></span>
                              <ng-casto-button
                                class="secondary"
                                (click)="openDetailWorkbench()"
                                [label]="'installation.kitchen.workbench.details' | translate"></ng-casto-button>
                            </td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-tag"
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalWorkbench.discountedAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-discount"
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalWorkbench.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              <span
                                class="blue"
                                [innerHTML]="
                                  installationViewModel.extraPricing.totalWorkbench.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                ">
                              </span>
                            </td>
                          </tr>
                          @if (installationViewModel.extraPricing.totalWorkbenchPlan) {
                            <tr>
                              <td [innerHTML]="'installation.kitchen.workbench.custom' | translate"></td>
                              <td></td>
                              <td></td>
                              <td class="price">
                                <span
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalWorkbenchPlan.actualAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              </td>
                            </tr>
                          }
                          @if (installationViewModel.extraPricing.totalInstallation) {
                            <tr>
                              <td
                                [innerHTML]="'installation.kitchen.workbench.installation-package' | translate"></td>
                              <td></td>
                              <td></td>
                              <td class="price">
                                <span
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalInstallation.actualAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              </td>
                            </tr>
                          }
                          @if (installationViewModel.extraPricing.totalDelivery) {
                            <tr>
                              <td [innerHTML]="'installation.kitchen.workbench.delivery-package' | translate"></td>
                              <td></td>
                              <td></td>
                              <td class="price">
                                <span
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalDelivery.actualAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              </td>
                            </tr>
                          }
                        </table>
                      </td>
                    </tr>
                  } @else {
                    <tr>
                      <td [innerHTML]="'installation.kitchen.workbench.default-workbench' | translate"></td>
                      <td>
                        @if (installationViewModel.displayDiscount) {
                          <span
                            class="casto-tag"
                            [innerHTML]="
                              -installationViewModel.extraPricing.HBMWorkbench.discountedAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                            ">
                          </span>
                        }
                      </td>
                      <td>
                        @if (installationViewModel.displayDiscount) {
                          <span
                            class="casto-discount"
                            [innerHTML]="
                              installationViewModel.extraPricing.HBMWorkbench.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                            ">
                          </span>
                        }
                      </td>
                      <td class="price">
                        <span
                          [innerHTML]="
                            installationViewModel.extraPricing.HBMWorkbench.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                          ">
                        </span>
                      </td>
                    </tr>
                  }
                  @if (installationViewModel.currentPricing.totalComplementaryProduct?.actualAmount > 0) {
                    <tr>
                      <td [innerHTML]="'validation.kitchen.complementary-product'|translate">
                      </td>
                      <td>
                        @if (installationViewModel.displayDiscount) {
                          <span class="casto-tag"
                                [innerHTML]="-installationViewModel.currentPricing.totalComplementaryProduct.discountedAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td>
                        @if (installationViewModel.displayDiscount) {
                          <span class="casto-discount"
                                [innerHTML]="installationViewModel.currentPricing.totalComplementaryProduct.baseAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td class="price">
                            <span
                              [innerHTML]="installationViewModel.currentPricing.totalComplementaryProduct.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                  </span>

                      </td>
                    </tr>
                  }
                  <tr class="white">
                    <span class="ml" [innerHTML]="'installation.ml' | translate"></span>
                  </tr>
                </table>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="panel" id="installation">
      <div class="panel-content selectable" (click)="setWithInstallation(false)">
        <div class="casto-card">
          <div class="header">
            <span
              class="casto-title"
              [innerHTML]="'installation.kitchen.without-installation.title' | translate"></span>

            <ng-casto-button
              class="primary"
              [label]="'generic.details' | translate"
              (click)="setWithInstallation(true)"></ng-casto-button>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!(installationViewModel.currentInstallation?.withInstallation ?? true)) {
    <div class="panel" id="installation">
      <div class="panel-content selectable" (click)="setWithInstallation(true)">
        <div class="casto-card">
          <div class="header">
            @if (installationViewModel.displayTitleWithoutDelta || setWithInstallationLoading) {
              <span
                class="casto-title"
                [innerHTML]="'installation.kitchen.with-installation.title-without-delta' | translate"></span>
            } @else {
              <span
                class="casto-title"
                [innerHTML]="
                  'installation.kitchen.with-installation.title'
                    | translate
                      : {
                          amount: installationViewModel.currentPricing?.delta?.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></span>
            }
            <ng-casto-button
              class="primary"
              [label]="'generic.details' | translate"
              (click)="setWithInstallation(true)"></ng-casto-button>
          </div>
        </div>
      </div>
    </div>
    <div class="panel">
      <div class="panel-content">
        <div class="casto-card">
          <div class="header">
            <span
              class="casto-title"
              [innerHTML]="'installation.kitchen.without-installation.title' | translate"></span>
          </div>
          @if (!installationViewModel.currentInstallation?.withInstallation) {
            <div class="content">
              @if (installationViewModel.pricingLoading || installationViewModel.installationLoading || setWithInstallationLoading) {
                <table class="price-table">
                  <tr class="top-row">
                    <td>
                     <span
                       class="casto-title"
                       [innerHTML]="'installation.kitchen.without-installation.top-row-title' | translate"></span>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                      <p-skeleton width="5rem" height="1.25rem"></p-skeleton>
                    </td>
                  </tr>

                  <!-- Ligne dédiée pour le sous-tableau -->
                  <tr>
                    <td class="inner-table-cell">
                      <table class="inner-table">
                        <tr>
                          <td>
                            <p-skeleton width="25rem" height="1rem"></p-skeleton>
                          </td>
                          <td>
                          </td>
                          <td>
                          </td>
                          <td>
                            <p-skeleton width="5rem" height="1rem"></p-skeleton>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p-skeleton width="25rem" height="1rem"></p-skeleton>
                          </td>
                          <td>
                          </td>
                          <td>
                          </td>
                          <td>
                            <p-skeleton width="5rem" height="1rem"></p-skeleton>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p-skeleton width="25rem" height="1rem"></p-skeleton>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                      <p-skeleton width="5rem" height="1rem"></p-skeleton>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p-skeleton width="25rem" height="1rem"></p-skeleton>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td class="price">
                      <p-skeleton width="5rem" height="1rem"></p-skeleton>
                    </td>
                  </tr>

                  <tr class="white">
                    <span class="ml" [innerHTML]="'installation.ml' | translate"></span>
                  </tr>
                </table>
              } @else {
                <table class="price-table">
                  <tr class="top-row">
                    <td>
                      <span
                        class="casto-title"
                        [innerHTML]="'installation.kitchen.without-installation.top-row-title' | translate"></span>
                    </td>
                    <td>
                      @if (installationViewModel.displayDiscount) {
                        <span
                          class="casto-tag"
                          [innerHTML]="
                            'installation.kitchen.without-installation.top-row-tag'
                              | translate
                                : {
                                    discount: installationViewModel.displayDiscountValue,
                                    discountAmount:
                                      (-installationViewModel.currentPricing.totalWithoutFunding.discountedAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'),
                                  }
                          "></span>
                      }
                    </td>
                    <td>
                      @if (installationViewModel.displayDiscount) {
                        <span
                          class="casto-discount"
                          [innerHTML]="
                            installationViewModel.currentPricing.totalWithoutFunding.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                          "></span>
                      }
                    </td>
                    <td>
                      <span
                        class="blue"
                        [innerHTML]="
                          installationViewModel.currentPricing.totalWithoutFunding.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                        ">
                      </span>
                    </td>
                  </tr>

                  <!-- Ligne dédiée pour le sous-tableau -->
                  <tr>
                    <td class="inner-table-cell">
                      <table class="inner-table">
                        @for (
                          detail of installationViewModel.currentPricing.detailConception | keyvalue; track detail.key) {
                          <tr>
                            <td
                              [innerHTML]="'installation.kitchen.conception-details.' + detail.key | translate"></td>

                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-tag"
                                  [innerHTML]="
                                    -detail.value.discountedAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-discount"
                                  [innerHTML]="detail.value.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                </span>
                              }
                            </td>
                            <td class="price">
                              <span
                                [innerHTML]="detail.value.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>
                            </td>
                          </tr>
                        }
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td [innerHTML]="'installation.kitchen.delivery' | translate"></td>
                    <td></td>
                    <td></td>
                    <td>
                      <span
                        class="blue"
                        [innerHTML]="
                          installationViewModel.currentPricing.delivery.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                        ">
                      </span>
                    </td>
                  </tr>
                  @if (installationViewModel.isCustomWorkbenchOnly) {
                    <tr>
                      <td class="inner-table-cell">
                        <table class="inner-table">
                          <tr>
                            <td
                              [innerHTML]="'installation.kitchen.workbench.total-without-packages' | translate"></td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-tag"
                                  [innerHTML]="
                                    -installationViewModel.extraPricing.totalWorkbenchPlan.discountedAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-discount"
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalWorkbenchPlan.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              <span
                                class="blue"
                                [innerHTML]="
                                  installationViewModel.extraPricing.totalWorkbenchPlan.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                ">
                              </span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  } @else if (installationViewModel.isCustomWorkbench) {
                    <tr>
                      <td class="inner-table-cell">
                        <table class="inner-table">
                          <tr>
                            <td class="horizontal-align-with-gap">
                              <span [innerHTML]="'installation.kitchen.workbench.total' | translate"></span>
                              <ng-casto-button
                                class="secondary"
                                (click)="openDetailWorkbench()"
                                [label]="'installation.kitchen.workbench.details' | translate"></ng-casto-button>
                            </td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-tag"
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalWorkbench.discountedAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              @if (installationViewModel.displayDiscount) {
                                <span
                                  class="casto-discount"
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalWorkbench.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              }
                            </td>
                            <td>
                              <span
                                class="blue"
                                [innerHTML]="
                                  installationViewModel.extraPricing.totalWorkbench.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                ">
                              </span>
                            </td>
                          </tr>
                          @if (installationViewModel.extraPricing.totalWorkbenchPlan) {
                            <tr>
                              <td [innerHTML]="'installation.kitchen.workbench.custom' | translate"></td>
                              <td></td>
                              <td></td>
                              <td class="price">
                                <span
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalWorkbenchPlan.actualAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              </td>
                            </tr>
                          }
                          @if (installationViewModel.extraPricing.totalInstallation) {
                            <tr>
                              <td
                                [innerHTML]="'installation.kitchen.workbench.installation-package' | translate"></td>
                              <td></td>
                              <td></td>
                              <td class="price">
                                <span
                                  [innerHTML]="
                                    installationViewModel.extraPricing.totalInstallation.actualAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              </td>
                            </tr>
                          }
                          @if (installationViewModel.extraPricing.totalDelivery) {
                            <tr>
                              <td [innerHTML]="'installation.kitchen.workbench.delivery-package' | translate"></td>
                              <td></td>
                              <td></td>
                              <td class="price">
                                <span
                                  [innerHTML]="
                                   installationViewModel.extraPricing.totalDelivery.actualAmount
                                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                                  ">
                                </span>
                              </td>
                            </tr>
                          }
                        </table>
                      </td>
                    </tr>
                  } @else {
                    <tr>
                      <td [innerHTML]="'installation.kitchen.workbench.default-workbench' | translate"></td>
                      <td>
                        @if (installationViewModel.displayDiscount) {
                          <span
                            class="casto-tag"
                            [innerHTML]="
                              -installationViewModel.extraPricing.HBMWorkbench.discountedAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                            ">
                          </span>
                        }
                      </td>
                      <td>
                        @if (installationViewModel.displayDiscount) {
                          <span
                            class="casto-discount"
                            [innerHTML]="
                              installationViewModel.extraPricing.HBMWorkbench.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                            ">
                          </span>
                        }
                      </td>
                      <td class="price">
                        <span
                          [innerHTML]="
                            installationViewModel.extraPricing.HBMWorkbench.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                          ">
                        </span>
                      </td>
                    </tr>
                  }
                  @if (installationViewModel.currentPricing.totalComplementaryProduct?.actualAmount > 0) {
                    <tr>
                      <td [innerHTML]="'validation.kitchen.complementary-product'|translate">
                      </td>
                      <td>
                        @if (installationViewModel.displayDiscount) {
                          <span class="casto-tag"
                                [innerHTML]="-installationViewModel.currentPricing.totalComplementaryProduct.discountedAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td>
                        @if (installationViewModel.displayDiscount) {
                          <span class="casto-discount"
                                [innerHTML]="installationViewModel.currentPricing.totalComplementaryProduct.baseAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>


                        }
                      </td>
                      <td class="price">
                            <span
                              [innerHTML]="installationViewModel.currentPricing.totalComplementaryProduct.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                                  </span>

                      </td>
                    </tr>
                  }
                  <tr class="white">
                    <span class="ml" [innerHTML]="'installation.ml' | translate"></span>
                  </tr>
                </table>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  } @else {
    <div class="panel feature-disabled-panel">
      <div class="panel-content">
        <div class="alert alert-warning m-0 text-center" [innerHTML]="'feature-settings.warning.pose' | translate"></div>
      </div>
    </div>
  }

</div>
